var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "start-page primary" },
    [
      _c("h1", { staticClass: "title" }, [_vm._v("IDBStudio")]),
      _vm._v(" "),
      _vm.dbList.length == 0
        ? _c("div", { staticClass: "loader" }, [
            _vm._v("\n        Loading "),
            _c("i", { staticClass: "fas fa-spin fa-spinner margin-left-10px" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.dbList.length > 0
        ? _c(
            "v-layout",
            { staticClass: "margin-top-100px", attrs: { row: "" } },
            [
              _c(
                "v-flex",
                {
                  staticStyle: { margin: "0 auto", display: "inherit" },
                  attrs: { xs12: "", sm5: "", md4: "" }
                },
                [
                  _c(
                    "div",
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.dbList,
                          label: "--Select Database--",
                          solo: ""
                        },
                        model: {
                          value: _vm.selectedDb,
                          callback: function($$v) {
                            _vm.selectedDb = $$v
                          },
                          expression: "selectedDb"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticStyle: { "margin-left": "50px", padding: "0 30px" },
                      attrs: { color: "info" },
                      on: { click: _vm.connectDb }
                    },
                    [_vm._v("Connect")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      {
        staticStyle: {
          color: "white",
          bottom: "50px",
          position: "absolute",
          "text-align": "center",
          width: "100%"
        }
      },
      [
        _c("span", [
          _vm._v("\n            Created with "),
          _c("i", {
            staticClass: "fas fa-heart",
            staticStyle: { color: "red" }
          }),
          _vm._v(" by "),
          _c(
            "a",
            {
              staticStyle: { color: "darkblue" },
              attrs: { href: "https://twitter.com/ujjwal_kr_gupta" }
            },
            [_vm._v("Ujjwal Gupta")]
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }